import React, { Component } from 'react'

class Button extends Component {

    render() {
        const { className, buttonTitle, buttonClick, isDisabled } = this.props;

        return (
            <button onClick={ buttonClick } disabled={isDisabled ? true : false} className={className}>{ buttonTitle }</button>
        );
    }
}

export default Button